import { HttpContextToken } from '@angular/common/http'

// Anfragen mit diesem Token behandeln ihre Fehler selbst: kein Logout bei 401
// und die HttpErrorResponse kommt unverändert an (Status bleibt auswertbar).
// Gedacht für Login-Versuche, bei denen ein 401 kein abgelaufener Login ist
// (siehe bentomax/hawk#596).
export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false)
